import type { LSK } from '@shared/utils/storage/config';

export const setLocalStorage = (key: LSK, value: any, onError?: (e: any) => void) => {
	try {
		const _val = JSON.stringify(value);
		localStorage.setItem(key, _val);
	} catch (e) {
		onError && onError(e);
	}
};

export const getLocalStorage = (key: LSK, initValue = '[]', onError?: (e: any) => void) => {
	try {
		const val = localStorage.getItem(key) || initValue;
		const _val = JSON.parse(val);
		return _val;
	} catch (e) {
		onError && onError(e);
	}
};

export const removeLocalStorage = (key: LSK, onError?: (e: any) => void) => {
	try {
		localStorage.removeItem(key);
	} catch (e) {
		onError && onError(e);
	}
};

export const setSessionStorage = (key: string, value: any, onError?: (e: any) => void) => {
	try {
		const _val = JSON.stringify(value);
		sessionStorage.setItem(key, _val);
	} catch (e) {
		onError && onError(e);
	}
};

export const getSessionStorage = (key: string, initValue = '[]', onError?: (e: any) => void) => {
	try {
		const val = sessionStorage.getItem(key) || initValue;
		const _val = JSON.parse(val);
		return _val;
	} catch (e) {
		onError && onError(e);
	}
};

export const removeSessionStorage = (key: string, onError?: (e: any) => void) => {
	try {
		sessionStorage.removeItem(key);
	} catch (e) {
		onError && onError(e);
	}
};
